import {
  AUTH_INITIALIZED,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGOUT,
} from '../../store/types';

const initialState = {
  token: null,
  user: null,
  isAuthenticated: false,
  initialized: false,
  loading: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token,
        user: action.payload.user,
        loading: false,
        error: null,
      };

    case LOGIN_FAIL:
    case REGISTER_FAIL:
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        loading: false,
        error: action.payload,
      };

    case LOGOUT:
      return {
        ...initialState,
        initialized: state.initialized, // Preserve initialized state
      };

    case AUTH_INITIALIZED:
      return {
        ...state,
        initialized: true,
        loading: false,
      };

    default:
      return state;
  }
};

export default authReducer;